import FooterBlock from "../../components/Footer/Footer";
import ProfileLoggedInView from "./components/ProfileLoggedinView";
import { User as UserModel } from "../../models/user";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";

interface ProfilePageProps {
  loggedInUser: UserModel | null;
}

const ProfilePage = ({ loggedInUser }: ProfilePageProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
        {loggedInUser ? (
          <>
            <ProfileLoggedInView />
            <FooterBlock />
          </>
        ) : (
          <div className="pageBlock">
            <LoggedOutView />
          </div>
        )}
      </div>
  );
};

export default ProfilePage;
